import React, { useEffect } from 'react';
import Image from 'gatsby-plugin-sanity-image';
import { Parallax, Background } from 'react-parallax';

// Hooks
import { useInView } from 'react-intersection-observer';
import { useAppState } from '../../state/appState';

const StandardBanner = ({ heading, banner }) => {
  const { setReverseHeader } = useAppState();
  const [ref, inView] = useInView({
    /* Optional options */
    threshold: 0,
  });
  useEffect(() => {
    setReverseHeader(inView);
    return () => {
      setReverseHeader(false);
    };
  }, [inView, setReverseHeader]);

  return (
    <Parallax
      className="relative w-full h-120 md:h-140 flex items-center justify-center bg-black overflow-hidden"
      strength={200}
    >
      <h1
        className="font-displayDrop text-3xl md:text-6xl text-center leading-tight relative z-20 text-white px-gutter"
        ref={ref}
      >
        {heading}
      </h1>
      <Background className="w-screen h-120 md:h-140 opacity-80">
        <Image className="w-full h-full absolute object-cover" {...banner} />
      </Background>
    </Parallax>
  );
};

export default StandardBanner;
